import { Anticoagulant } from 'gql/types';

export const donorStatuses = Object.values(Anticoagulant).map((value) => {
  return {
    value,
    label: value,
  };
});
